import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-promo-image-modal',
  standalone: true,
  imports: [CommonModule, NgbModalModule],
  templateUrl: './promo-image-modal.component.html',
  styles: [
    `
      .modal-body {
        max-width: 500px;
      }
    `,
  ],
})
export class PromoImageModalComponent {
  @Input() imageUrl: string;
  @Input() linkUrl: string;

  constructor(public readonly activeModal: NgbActiveModal) {}
}
